import { MainPageRouters } from "./mainPage.js";
import { ServiceAgreementRouters } from "./serviceAgreement.js";
import { PrivatePolicyRouters } from "./privatePolicy.js";
import { SearchAddressRouters } from "./searchAddress.js";
import { DeviceDataRouters } from "./deviceData.js";

const routes = [
    ...MainPageRouters,
    ...ServiceAgreementRouters,
    ...PrivatePolicyRouters,
    ...SearchAddressRouters,
    ...DeviceDataRouters,
];

export default routes;
